import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MomentPreferences } from '../models/moment-preferences.model';
import * as moment from 'moment';

@Component({
  selector: 'appointment-moment-preferences',
  template: require('./appointment-moment-preferences.component.html'),
  styles: [require('./appointment-moment-preferences.component.scss')],
})

export class AppointmentMomentPreferencesComponent {
  @Input() preferences: MomentPreferences
  @Input() soonestPossibleDate: moment.Moment;
  @Input() datepickerCalendarPlacement: string = 'bottom'; // Can either be 'top' or 'bottom'
  @Input() titleId: string;
  @Input() allowConsecutiveAppointments: boolean = false;

  @Output() onDateSet: EventEmitter<string> = new EventEmitter<string>();

  onSettedDate($event: string) {
    if ($event) {
      this.preferences.type = 'period';
      this.onDateSet.emit($event)
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/appointment-moment-preferences/appointment-moment-preferences.component.ts